exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@-webkit-keyframes GroupForm_fadeIn__2Dz4X {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n@keyframes GroupForm_fadeIn__2Dz4X {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n@-webkit-keyframes GroupForm_fadeOut__jH3RX {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n@keyframes GroupForm_fadeOut__jH3RX {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n.GroupForm_groupForm__25nD_ {\n  display: -webkit-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n          flex-direction: column;\n  width: 1000px;\n  min-width: 700px; }\n  .GroupForm_groupForm__25nD_ .GroupForm_paper__2htuo {\n    padding: 16px 24px 26px 24px;\n    box-sizing: border-box;\n    margin-bottom: 16px; }\n  .GroupForm_groupForm__25nD_ .GroupForm_topbar__1MY6D {\n    display: -webkit-flex;\n    display: flex;\n    -webkit-justify-content: flex-end;\n            justify-content: flex-end; }\n  .GroupForm_groupForm__25nD_ .GroupForm_rolesWrapper__3U0zp {\n    display: -webkit-flex;\n    display: flex;\n    -webkit-flex-wrap: wrap;\n            flex-wrap: wrap; }\n", ""]);

// exports
exports.locals = {
	"color": "#ff3b00",
	"colorSecondary": "#4caf50",
	"colorContrastText": "#ffffff",
	"colorLight": "#ff7349",
	"colorDark": "#ce3000",
	"colorSecondaryLight": "#81c784",
	"colorSecondaryDark": "#388e3b",
	"hostColor": "#eb8315",
	"hostColorSecondary": "#f44336",
	"hostColorContrastText": "#ffffff",
	"hostColorLight": "#ffa74a",
	"hostColorDark": "#cf6a00",
	"groupForm": "GroupForm_groupForm__25nD_",
	"paper": "GroupForm_paper__2htuo",
	"topbar": "GroupForm_topbar__1MY6D",
	"rolesWrapper": "GroupForm_rolesWrapper__3U0zp",
	"fadeIn": "GroupForm_fadeIn__2Dz4X",
	"fadeOut": "GroupForm_fadeOut__jH3RX"
};